import { render, staticRenderFns } from "./my-activity.vue?vue&type=template&id=0d636605&scoped=true&"
import script from "./my-activity.vue?vue&type=script&lang=js&"
export * from "./my-activity.vue?vue&type=script&lang=js&"
import style0 from "./my-activity.vue?vue&type=style&index=0&id=0d636605&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d636605",
  null
  
)

export default component.exports